import React from 'react'
import { useSelector } from 'react-redux';
import {Navigate, Outlet} from 'react-router-dom'
import AccessDenied from '../components/admin/pages/AuthPage/AccessDenied';
import { useRefresh } from '../components/common/hook';

export const publicPage = ['/', 'exam']

function PrivateRoutes({authentication}) {
    const loginInfo = useSelector(state => state.login);
    const defaultMenu = loginInfo.menuList;
    const refresh = useRefresh();

    if (authentication) { // 로그인 필요
        if (sessionStorage.getItem("isAuthenticated") == "1") { // 로그인 O
            if (authentication >= loginInfo.admin.level) { // 권한 O
                return <Outlet/>;
            } else { // 권한X
                return <AccessDenied to={"/main/dashboard/"+ defaultMenu[0].companyId + "/" + defaultMenu[0].branch[0].id}/>
            }
        } else { // 로그인X
            return <Navigate to={"/auth/login"}/>
        }
    } else { // 로그인 필요 X
        if (sessionStorage.getItem("isAuthenticated") == "1") { // 로그인 O
            if (loginInfo.admin.level == 1) {
                return <Navigate to={"/dashboard/"}/>
            } else {
                if (defaultMenu[0]) { // 첫 번째 메뉴 페이지로 이동
                    if (defaultMenu[0].branch.length > 1) { // 지점이 2개 이상일 경우
                        // 첫 번째 업체 > 전체
                        return <Navigate to={"/main/dashboard/"+ defaultMenu[0].companyId + "/0"}/>
                    }
                    // 첫 번째 업체 > 첫 번째 지점
                    return <Navigate to={"/main/dashboard/"+ defaultMenu[0].companyId + "/" + defaultMenu[0].branch[0].id}/>
                } else {
                    refresh.refetch();
                }
            }

            return 
        } else {
            return <Outlet/>  
        }
    }
}

export default PrivateRoutes